import { isEmpty } from '@/utils/common'

const storage = {
  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  get(key) {
    const item = localStorage.getItem(key)
    if (!isEmpty(item)) {
      return JSON.parse(item)
    } else {
      return null
    }
  },
  remove(key) {
    localStorage.removeItem(key)
  },
  clear() {
    localStorage.clear()
  }
}

export default storage
